import {Alert, Box, Button, Modal, Typography} from '@mui/material';
import React, {useCallback} from 'react';
import styles from '../../styles';
import {useTranslation} from 'react-i18next';

interface Props {
  open: boolean;
  setOpen: (open: boolean) => void;
  quantity?: number;
  email?: string;
}

const AccessShopifySubscriptionModal: React.FC<Props> = ({
  open,
  setOpen,
  quantity,
  email,
}) => {
  const {t} = useTranslation();

  const handleClose = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <Box sx={styles.modal}>
        <Box sx={{display: 'flex', flexDirection: 'column'}}>
          <Typography variant="h4" sx={{mb: 1}}>
            {t('membership.updatePaymentInformation')}
          </Typography>
          {email && (
            <>
              <Typography variant="body1" sx={{mb: 1}}>
                {t('membership.accessShopifySubscriptionInstructions')}
              </Typography>
              <Typography variant="body1" sx={{mb: 1, fontWeight: 'bold'}}>
                {email}
              </Typography>
            </>
          )}
          {quantity && quantity > 1 && (
            <Alert severity="warning" variant="outlined" sx={{mb: 2}}>
              {t('membership.thisWillAffectAllSubscriptions', {
                quantity,
              })}
            </Alert>
          )}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end',
            }}>
            <Button
              variant="contained"
              sx={{mb: 1, mr: 1}}
              onClick={async () => {
                window.open(
                  `${process.env.REACT_APP_MAIN_WEBSITE_BASE_URL}/tools/recurring/login`,
                  '_blank',
                );
              }}>
              {t('membership.updatePaymentInformation')}
            </Button>
            <Button variant="outlined" sx={{mb: 1}} onClick={handleClose}>
              {t('general.close')}
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default AccessShopifySubscriptionModal;
